<a
  [class.disabled]="item.hidden"
  style="width: 100%"
  #rla="routerLinkActive"
  routerLinkActive="active-link"
  [routerLink]="item.link ?? null"
  fxLayout
  fxLayoutAlign="start center"
  class="nav-parent {{ item.class }}"
  id="{{ item.id }}"
  (click)="visitLink()">
  <div class="nav-item-container">
    <div fxLayoutAlign="center center" class="nav-item" fxFlex="40px" style="width: 40px">
      <sbnb-icon [icon]="item.icon" class="nav__fixed"></sbnb-icon>
    </div>
    <div fxFlex="" class="nav_text" [@enterAnimation]>
      {{ item.expandedText }}
    </div>
  </div>
  <div *ngIf="details" class="nav_arrow">
    <div>
      <div *ngIf="item.badgeCountKey && badgeCounts && badgeCounts[item.badgeCountKey] > 0" class="badge">
        {{ badgeCounts[item.badgeCountKey] > 99 ? '99+' : badgeCounts[item.badgeCountKey] }}
      </div>
    </div>
  </div>
</a>
